import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { CredibilitySection } from '../components/sections/CredibilitySection';
import { PricingSection } from '../components/sections/PricingSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-gray-700 font-body selection:bg-primary/30 selection:text-white" data-id="element-339">
      <HeroSection data-id="element-340" />
      <ProblemSection data-id="element-341" />
      <SolutionSection data-id="element-342" />
      <AudienceSection data-id="element-343" />
      <ResultsSection data-id="element-344" />
      <BenefitsSection data-id="element-345" />
      <PricingSection data-id="element-346" />
      <CredibilitySection data-id="element-347" />
      <HowItWorksSection data-id="element-348" />
      <TestimonialSection data-id="element-349" />
      <FAQSection data-id="element-350" />
      <FooterSection data-id="element-351" />
      <SocialProofPopup data-id="element-352" />
    </main>;
}